import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useL10n } from "../l10n";
const sameDecimal = (a, b) => a === b || (a !== null && b !== null && a.eq(b));
const MAX_FRACTION_DIGITS = 20;
const DoraDecimalInput = (props) => {
    const { id, label, helperText, placeholder, disabled, fullWidth, size, error, value, onChange, onBlur, controlField, } = props;
    const l10n = useL10n();
    const format = useCallback((v) => v === null
        ? ""
        : l10n.formatNumber(v, Math.min(v.decimalPlaces(), MAX_FRACTION_DIGITS)), [l10n]);
    const currentValue = (controlField ? controlField.value : value) ?? null;
    const [text, setText] = useState(() => format(currentValue));
    const emitted = useRef(currentValue);
    useEffect(() => {
        if (!sameDecimal(currentValue, emitted.current)) {
            emitted.current = currentValue;
            setText(format(currentValue));
        }
    }, [currentValue, format]);
    const emit = (v) => {
        emitted.current = v;
        if (controlField) {
            controlField.onChange(v);
        }
        onChange?.(v);
    };
    const handleChange = (raw) => {
        setText(raw);
        emit(raw.trim() === "" ? null : l10n.parseDecimal(raw));
    };
    const handleBlur = () => {
        if (emitted.current !== null) {
            setText(format(emitted.current));
        }
        controlField?.onBlur?.();
        onBlur?.();
    };
    const unparseable = text.trim() !== "" && l10n.parseDecimal(text) === null;
    return (_jsx(TextField, { ...(id && { id }), label: label, placeholder: placeholder, size: size || "small", fullWidth: fullWidth, disabled: disabled, value: text, onChange: (e) => handleChange(e.target.value), onBlur: handleBlur, error: !!error || unparseable, helperText: helperText, inputProps: { inputMode: "decimal" } }));
};
const UFDoraDecimalInput = (props) => {
    const { name, control, ...rest } = props;
    return (_jsx(Controller, { name: name, control: control, render: ({ field, fieldState }) => (_jsx(DoraDecimalInput, { ...rest, controlField: field, error: !!rest.error || !!fieldState.error, helperText: fieldState.error?.message || rest.helperText })) }));
};
export { DoraDecimalInput, UFDoraDecimalInput };
//# sourceMappingURL=DoraDecimalInput.js.map